import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo, useCallback, memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Icon } from '../Icon/index';
import { ReactPortal } from '../ReactPortal';
import { useLockBodyScrollEffect } from '../useLockBodyScrollEffect';
import { widths, sizes, } from './constants';
const defaultProps = {
    children: [],
    closeOnEsc: true,
    closeOnOverlayClick: true,
    displayCloseButton: true,
    mobileFullscreen: false,
    onCloseClick: () => { },
    open: false,
    size: sizes.small,
    zIndex: 9999,
};
const Modal = ({ children = defaultProps.children, closeOnEsc = defaultProps.closeOnEsc, closeOnOverlayClick = defaultProps.closeOnOverlayClick, displayCloseButton = defaultProps.displayCloseButton, mobileFullscreen = defaultProps.mobileFullscreen, onCloseClick = defaultProps.onCloseClick, open = defaultProps.open, size = defaultProps.size, zIndex = defaultProps.zIndex, }) => {
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            onCloseClick();
        }
    }, [
        onCloseClick,
    ]);
    const overlayStyles = useMemo(() => (css `
        ${styleUtils.borderBox}
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        height: 100%;
        justify-content: center;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: ${zIndex};
      `), [
        zIndex,
    ]);
    const modalWindowStyles = useMemo(() => (css `
        background-color: ${theme.colors.gray100};
        box-shadow: 0 0 ${styleUtils.rem(3)} 0 rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        max-height: 90%;
        max-width: ${styleUtils.rem(widths[size])};
        overflow: auto;
        position: relative;
        width: 90%;

        ${mobileFullscreen && theme.media.lessThan('small')(css `
            height: 100%;
            max-height: 100%;
            max-width: 100%;
            width: 100%;
          `)}
      `), [
        mobileFullscreen,
        size,
    ]);
    const closeButtonStyles = useMemo(() => (css `
        ${styleUtils.buttonReset}
        cursor: pointer;
        line-height: 0;
        position: absolute;
        top: ${theme.spacing.x2};
        right: ${theme.spacing.x2};
        z-index: ${zIndex};
      `), [
        zIndex,
    ]);
    useLockBodyScrollEffect({
        isLocked: open,
    });
    return (_jsx(ReactPortal, { children: _jsx("div", { children: open && (_jsx("div", Object.assign({ css: overlayStyles, "data-test-ref": "modalOverlay", onClick: closeOnOverlayClick ? onCloseClick : undefined, onKeyDown: closeOnEsc ? handleKeyDown : undefined, role: "presentation", tabIndex: -1 }, { children: _jsxs("div", Object.assign({ css: modalWindowStyles, onClick: (event) => {
                        event.stopPropagation();
                    }, role: "presentation" }, { children: [displayCloseButton && (_jsx("button", Object.assign({ css: closeButtonStyles, "data-test-ref": "modalCloseBtn", onClick: onCloseClick, type: "button" }, { children: _jsx(Icon, { type: "close" }) }))), children] })) }))) }) }));
};
const MemoizedModal = memo(Modal);
export { MemoizedModal as Modal };
// MC-1068 Temporary hack for Storybook.
export default Modal;
